module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Rain#2-d850e8ac12728e01ca4043db88e51ed8.svg";